export default [
    {
        path: '/storage/jobs',
        name: 'StorageJobs',
        meta: {
            requiresAuth: true,
        },
        components: {
            default: () => import('@views/storage/StorageJobsIndex.vue'),
        },
    },
];
